import { Col, Row } from "../components/Grid";
import ContentBlock from "../components/ContentBlock";
import FacePhoto from "../components/FacePhoto";
import HtmlContainer from "../components/HtmlContainer";
import PropTypes from "prop-types";
import React from "react";
import TextSection from "../components/TextSection";
import injectSheet from "react-jss";
import SimonFace from "../img/Face-Simon.jpg";
import AidanFace from "../img/Face-Aidan.jpg";
import DanielleFace from "../img/Face-Danielle.jpg";
import SarahFace from "../img/Face-Sarah.jpg";
import MattFace from "../img/Face-Matt.jpg";
import OllieFace from "../img/Face-Ollie.jpg";
import SeanFace from "../img/Face-Sean.jpg";
import AdamFace from "../img/Face-Adam.jpg";

const styles = theme => ({
  content: {
    height: "100%"
  },
  text: {
    fontSize: "1.3rem",
    fontWeight: 200,
    paddingLeft: "5rem",
    paddingRight: "5rem",
    marginBottom: "2rem",
    "@media (max-width: 823px)": {
      padding: 0,
      marginLeft: "1rem",
      marginRight: "1rem",
      width: "90%",
      lineHeight: "1.5"
    },
    "& h1": {
      fontSize: "5.4rem",
      fontWeight: 200,
      margin: 0,
      "@media (max-width: 823px)": {
        fontSize: "3rem"
      }
    },
    "& a": {
      color: theme.colours.content.fontColor
    },
    "& h2": {
      fontSize: "5.4rem",
      fontWeight: 200,
      textAlign: "center",
      margin: 0,
      "@media (max-width: 823px)": {
        fontSize: "3rem"
      }
    }
  },
  container: {
    width: "100%"
  },
  rowContainer: {
    maxWidth: "1999px"
  },
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  meet: {
    marginTop: "10vh"
  },
  about: {
    width: "1000px",
    "@media (max-width: 823px)": {
      width: "90%"
    }
  },
  photoContainer: {
    width: "33%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "32px",
    "@media (max-width: 1000px)": {
      width: "50%"
    }
  }
});

const AboutPage = ({ classes, data }) => (
  <div className={classes.content}>
    <ContentBlock>
      <div className={classes.container}>
        <div className={classes.center}>
          <div className={classes.about}>
            <TextSection className={classes.text}>
              <HtmlContainer content={data.MainContent.html} />
            </TextSection>
          </div>
        </div>
        <div className={classes.meet}>
          <TextSection className={classes.text}>
            <HtmlContainer content={data.MeetHeader.html} />
          </TextSection>
          <div className={classes.center}>
            <div className={classes.rowContainer}>
              <Row around wrap>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={SimonFace}
                    employee="Simon"
                    position="CEO &amp; Founder"
                  />
                </div>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={AidanFace}
                    employee="Aidan"
                    position="Developer"
                  />
                </div>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={SarahFace}
                    employee="Sarah"
                    position="Operations Manager"
                  />
                </div>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={MattFace}
                    employee="Matt"
                    position="Head of Marketing"
                  />
                </div>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={OllieFace}
                    employee="Ollie"
                    position="Head of Support"
                  />
                </div>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={SeanFace}
                    employee="Sean"
                    position="Parliamentary Liaison &nbsp;&nbsp;&nbsp; Australia"
                  />
                </div>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={AdamFace}
                    employee="Adam"
                    position="Business Development Manager"
                  />
                </div>
                <div className={classes.photoContainer}>
                  <FacePhoto
                    image={DanielleFace}
                    employee="Danielle"
                    position="Community Engagement &amp; Growth"
                  />
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </ContentBlock>
  </div>
);

AboutPage.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object
};

export default injectSheet(styles)(AboutPage);

/* global graphql */
export const AboutQuery = graphql`
  query AboutQuery {
    MainContent: markdownRemark(frontmatter: { name: { eq: "About" } }) {
      html
      frontmatter {
        name
      }
    }
    MeetHeader: markdownRemark(frontmatter: { name: { eq: "AboutMeet" } }) {
      html
      frontmatter {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/about.jsx